// NOTE: 상세페이지 조회 이벤트 스크립트
const collect = () => {
  try {
    if (!window.karrotPixel || !window.karrotPixel.trackerId) return
    window.karrotPixel.track('ViewContent')
  } catch (error) {
    const daagnScriptError = error as Error
    window.DD_LOGS?.logger.warn(daagnScriptError.message, undefined, daagnScriptError)
    window.Rollbar?.warning(daagnScriptError.message, daagnScriptError)
  }
}

export default collect
